import CenterCostType from './CenterCostType';
import { CenterCostSectionCode } from './CenterCostTypes';

class CenterCostSection {
  static CANAL = 'canal' as CenterCostSectionCode;
  static DELEGACION = 'delegacion' as CenterCostSectionCode;
  static DEPARTAMENTO = 'departamento' as CenterCostSectionCode;
  static PROYECTO = 'proyecto' as CenterCostSectionCode;
  static CONFIGURACION = 'config' as CenterCostSectionCode;

  constructor(private code: CenterCostSectionCode) {}

  public static canal(): CenterCostSection {
    return new CenterCostSection(CenterCostSection.CANAL);
  }

  public static delegacion(): CenterCostSection {
    return new CenterCostSection(CenterCostSection.DELEGACION);
  }

  public static departamento(): CenterCostSection {
    return new CenterCostSection(CenterCostSection.DEPARTAMENTO);
  }

  public static proyecto(): CenterCostSection {
    return new CenterCostSection(CenterCostSection.PROYECTO);
  }

  public isConfiguracion(): boolean {
    return this.code === CenterCostSection.CONFIGURACION;
  }

  public isProyecto(): boolean {
    return this.code === CenterCostSection.PROYECTO;
  }

  public static toArray(): CenterCostSectionCode[] {
    return [
      CenterCostSection.CANAL,
      CenterCostSection.DELEGACION,
      CenterCostSection.DEPARTAMENTO,
      CenterCostSection.PROYECTO,
      CenterCostSection.CONFIGURACION,
    ];
  }

  public centerCostType(): CenterCostType | null {
    switch (this.code) {
      case CenterCostSection.CANAL:
        return CenterCostType.channel();
      case CenterCostSection.DELEGACION:
        return CenterCostType.delegation();
      case CenterCostSection.DEPARTAMENTO:
        return CenterCostType.area();
      case CenterCostSection.PROYECTO:
        return CenterCostType.project();
      default:
        return null;
    }
  }

  public centerCostTypeOrFail(): CenterCostType {
    const type = this.centerCostType();
    if (type) {
      return type;
    }
    throw new Error(`No CenterCostType found for section: ${this.code}`);
  }

  public translationKey(): string {
    return `center_cost.${this.code}`;
  }

  public value(): CenterCostSectionCode {
    return this.code;
  }
}

export default CenterCostSection;
